// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-list-item__title[data-v-09eb679e] {\n  font-size: 14px;\n}\n.empty-cart[data-v-09eb679e] {\n  font-size: 86px !important;\n  color: rgba(135, 135, 135, 0.15) !important;\n}\n.total-amount[data-v-09eb679e] {\n  font-size: 20px;\n}", ""]);
// Exports
module.exports = exports;
